import { handleActions } from 'redux-actions'
// import { setOnSuccess } from 'lp-redux-api'
// import { selectorForSlice } from 'lp-redux-utils'
// import * as apiActions from 'api-actions'

const reducerKey = 'profile'
// const slice = 'root.educatorPortal.profile'

const initialState = {}

const reducer = handleActions({}, initialState)

// const select = selectorForSlice(slice)

const selectors = {}

export { reducer, selectors, reducerKey }
